<h1>Dashboard</h1>
@if (!loginDisplay) {
<div>
    <p class="welcome">Welcome to Abeona</p>
    <p>Please sign-in.</p>
</div>
} @else {
<div class="review-items">
    <!-- 
    <h2>Testing</h2>
    <p>Welcome to the first feedback session for the Campfire project where you can review what we’ve been working on and
    provide us with valuable feedback. Below you will find 5 applicants that are ready for review followed by a short
    feedback survey that we would be grateful if you completed. Additionally, if you have any ideas you would like to
    share, you can submit them via the <a
        target="_blank"
        href="https://aifsdevuk.atlassian.net/jira/core/projects/FIRE/form/5?atlOrigin=eyJpIjoiNzJiNWU2NDlkNTkyNGMxNzhlYzhjMWQ5YzdhMTg4MDkiLCJwIjoiaiJ9">ideas
        form</a>.</p>
    <p>The application review process has been designed for you to assess whether or not an application is suitable to be
    shown to camps or not. Review the data on each page, click on any items that require additonal attention (click once
    to feedback to the applicant or interviewer, click twice to flag item as a concern), then proceed to the next page.</p>
    <p>This demo will be available for 1 week so please complete your feedback survey by <b>4th September</b>. If you
    experience any issues please contact <a
        href="https://teams.microsoft.com/l/chat/0/0?users=mtolfrey@aifs.co.uk">Michael Tolfrey</a>, <a
        href="mailto:mtolfrey@aifs.co.uk">mtolfrey&#64;aifs.co.uk</a>.</p>
    <p>Check out our <a target="_blank" href="https://aifsdevuk.atlassian.net/wiki/spaces/Abeona/blogs">project blog</a> to stay up to date
    with what we’re working on.</p> 

  <h2>Application Review Demo</h2>
  <ul>
    @for ( l of links; track l.jobId) {
    <li>
      <a routerLink="" (click)="startReview($event, l)">{{ l.name }}</a>
    </li>
    }
  </ul>
    
   Add the new applicant-log component 
    <div class="applicant-log-section">
        <h2>Applicant Log</h2>
        <app-applicant-log [applicantId]="1001961"></app-applicant-log>
    </div>
</div>
<div class="examples">
  <h2>Table Actions</h2>
  <div style="width: 100%">
    <app-cf-table
      *ngIf="users"
      [showSelectionBox]="false"
      [sortable]="true"
      [data]="users"
      [profileSizePx]="32"
      (onRowAction)="rowAction($event)"
    >
      <div firstAction class="action assign-tasks">
        <span>Assign new tasks</span>
        <span class="buttons">
          <app-cf-button
            [style]="ButtonStyle.Small"
            [type]="ButtonType.ToDo"
            (click)="rowActionPlus('T', 1)"
            >+1</app-cf-button
          >
          <app-cf-button
            [style]="ButtonStyle.Small"
            [type]="ButtonType.ToDo"
            (click)="rowActionPlus('T', 10)"
            >+10</app-cf-button
          >
          <span class="counter"
            >@if(currentRowActionCounter > 0) {
            {{ currentRowActionCounter }}
            }</span
          >
        </span>
        <span class="save"
          ><app-cf-button
            [style]="ButtonStyle.Small"
            [type]="ButtonType.Success"
            (click)="rowActionSaveChange()"
            >Save</app-cf-button
          ></span
        >
      </div>

      <div secAction class="action edit-user">
        <span>Edit user</span>
        <span class="buttons">
          <app-cf-button
            [style]="ButtonStyle.Small"
            [type]="ButtonType.ToDo"
            (click)="rowActionPlus('U', 1)"
            >+1</app-cf-button
          >
          <app-cf-button
            [style]="ButtonStyle.Small"
            [type]="ButtonType.ToDo"
            (click)="rowActionPlus('U', 10)"
            >+10</app-cf-button
          >
          <span class="counter"
            >@if(currentRowActionCounter > 0) {
            {{ currentRowActionCounter }}
            }</span
          >
        </span>
        <span class="save"
          ><app-cf-button
            [style]="ButtonStyle.Small"
            [type]="ButtonType.Success"
            (click)="rowActionSaveChange()"
            >Save</app-cf-button
          ></span
        >
      </div>

      
      <div secondAction class="action edit-user">
        <span>Edit user</span>
        <span class="buttons">
          <app-cf-button
            [style]="ButtonStyle.Small"
            [type]="ButtonType.ToDo"
            (click)="rowActionPlus('U', 1)"
            >+1</app-cf-button
          >
          <app-cf-button
            [style]="ButtonStyle.Small"
            [type]="ButtonType.ToDo"
            (click)="rowActionPlus('U', 10)"
            >+10</app-cf-button
          >
          <span class="counter"
            >@if(currentRowActionCounter > 0) {
            {{ currentRowActionCounter }}
            }</span
          >
        </span>
        <span class="save"
          ><app-cf-button
            [style]="ButtonStyle.Small"
            [type]="ButtonType.Success"
            (click)="rowActionSaveChange()"
            >Save</app-cf-button
          ></span
        >
      </div>

      <div thirdAction class="action remove-user">
        <span>Unassign all tasks and remove user?</span>
        <span class="save"
          ><app-cf-button
            [style]="ButtonStyle.Small"
            [type]="ButtonType.Danger"
            (click)="rowActionSaveChange()"
            >Remove</app-cf-button
          ></span
        >
      </div>
    </app-cf-table>
  </div>
-->
    <div class="map">
        <app-cf-map [locations]="locations" [mapWidth]="500" (mapIsLoaded)="mapLoaded($event)"
            (currentLocationChanged)="mapLocationChanged($event)"
            (locationSelected)="mapLocationChanged($event)"></app-cf-map>
        <div class="location-details">
            @if(hasLocation) {
            <div class="location" [innerHTML]="location"></div>
            @if(canAdd) {
            <app-cf-button [style]="ButtonStyle.Normal" [type]="ButtonType.Default" (click)="addSelectedLocation()">Add
                Location</app-cf-button>
            }
            }
        </div>
    </div>
</div>
}